import { onDomReady } from '@scripts/utils/onDomReady';
import './modules/buttonTop.js';
import './modules/burger.js';
import { submitFormData } from '@scripts/modules/sendFormData.js';
import initValidation from '@scripts/utils/initValidation.js';
// import NiceSelect from '@scripts/modules/niceSelect.js';
import NiceSelect from 'nice-select2';

async function contactForms() {
  const subscribeForm = document.querySelector('.js-subscribe form');
  const actionUrlForm = `${window.wp_data.ajax}?action=subscribeForm`;

  if (!subscribeForm) return;
  const validator = await initValidation({
    formSelector: subscribeForm,
    validateFields: {
      email: '.js-subscribe form input[type="email"]',
      submit: '.js-subscribe form input[type="submit"]',
    },
  });

  submitFormData({
    fetchUrl: actionUrlForm,
    formElement: subscribeForm,
    formValidation: validator,

    onSuccess: (result) => {
      const title = document.querySelector('.c-footer__form h3');
      if (title) title.textContent = result.data?.message || 'Subscription confirmed. Welcome!';
      subscribeForm.reset();
    },

    onError: (result) => {
      const title = document.querySelector('.c-footer__form h3');
      if (title) title.textContent = result.data?.message || 'Ooops! Some things went wrong. Please reload this page.';
    },
  });
}

onDomReady(() => {
  contactForms();
  const selects = document.querySelectorAll('.js-select');

  selects.forEach(function (select) {
    new NiceSelect(select, {
      searchable: false,
    });
  });

  const pageClass = document.querySelector('main').classList.value;
  switch (pageClass) {
    case 'p-main':
      break;
    case 'p-page':
      break;
    case 'p-archive':
      break;
    case 'p-single':
      break;
    default:
      // examplePage();
      break;
  }
});
